import { Box, MenuItem, Select, Typography } from "@material-ui/core"
import { Stack } from "@mui/material"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { specialCharacters } from "../../../../../data/specialChars"
import useValidation from "../../../../../hooks/useVal"
import { ActivityListFormProps } from "../../../../../types/activityListFormProps"
import { Question } from "../../../../../types/question"
import FormLayout from "./FormLayout"
import InputField from "./TextField"

export default function TimeForm(props: ActivityListFormProps) {
  const { question, onEditedQuestion, onEditedQuestionEntry } = props
  const { t } = useTranslation()
  const [formData, setFormData] = React.useState<Question>(question)
  const [tempForm, setTempForm] = React.useState<Question>()
  const { isValidated, addError, clearErrors } = useValidation()

  const handleSaveButtonClick = () =>
    onEditedQuestion?.({
      ...question,
      ...formData,
    })

  useEffect(() => {
    onEditedQuestionEntry?.({
      ...question,
      ...tempForm,
    })
  }, [tempForm])

  // Update form data on question change
  useEffect(() => {
    const formData = { ...question }

    // Make sure a time_format property is set correctly
    if (!formData.time_format) {
      formData.time_format = "standard"
    }

    setFormData(formData)
  }, [question])

  useEffect(() => {
    clearErrors()

    if (!formData.text) {
      addError(t("Title is required"))
    }

    if (!formData.human_id) {
      addError(t("ID is required"))
    }

    if (specialCharacters.test(formData.human_id)) {
      addError(t("Question ID contains illegal characters"))
    }

    if (formData.time_format !== "standard" && formData.time_format !== "military") {
      addError(t("Invalid time format"))
    }
  }, [formData])

  return (
    <FormLayout
      label={t("Specify your question")}
      description={t("Adding a question to which the answer given is a time.")}
    >
      <Stack spacing={2} mt={4}>
        <div>
          <InputField
            label={t("Your question")}
            placeholder={t("Type your question here..")}
            style={{
              marginTop: "10px",
            }}
            value={formData.text}
            onChange={(e) => setTempForm({ ...formData, text: e.target.value })}
          />
        </div>

        <div>
          <InputField
            label={t("Question ID")}
            placeholder={t("Type your question ID here..")}
            style={{
              marginTop: "10px",
            }}
            value={formData.human_id}
            onChange={(e) => setTempForm({ ...formData, human_id: e.target.value })}
          />
        </div>

        <div>
          <InputField
            label={t("Description (optional)")}
            placeholder={t("Enter a description...")}
            style={{
              marginTop: "10px",
            }}
            value={formData.description}
            onChange={(e) => setTempForm({ ...formData, description: e.target.value })}
          />
        </div>
      </Stack>

      <Box mt={4}>
        <Typography>{t("Format")}</Typography>
        {formData.time_format && (
          <Select
            value={formData.time_format}
            onChange={(e) =>
              setTempForm((prev) => {
                const value = e.target.value as string

                if (value !== "standard" && value !== "military") {
                  return prev
                }

                return { ...prev, time_format: value }
              })
            }
          >
            <MenuItem value="standard">{t("STANDARD TIME")}</MenuItem>
            <MenuItem value="military">{t("MILITARY TIME")}</MenuItem>
          </Select>
        )}

        <Box display="flex" justifyContent="space-between" width="100%" mt={2}></Box>
      </Box>
    </FormLayout>
  )
}
